<div [class.checkbox-card--selectable__active]="active"
     class="checkbox-card checkbox-card--selectable"
     style="background-image: url(https://www.uat.telenet.be/content/dam/www-telenet-be/tv-shop/img/STRM0008-item.jpg);">

  <app-badge [badgeCopy]="badgeCopyKey | translate" rendition="secondary" position="tr"></app-badge>

  <div class="status-indicator" [class.status-indicator__active]="isCardSelected">
    <img class="icon-tick" [class.display--none]="!isCardSelected" src="../../../../assets/icons/tick.svg" alt="netflix">
  </div>
  <div class="content">
    <h3 [innerHTML]="titleKey | translate"></h3>
    <app-spacer [spacerSize]="20"></app-spacer>

    <ul [innerHTML]="descriptionKey | translate"></ul>
  </div>
</div>
